import styled from 'styled-components'

export const BreadCrumbsContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: var(--color-breadcrumb-blue);
  border-radius: 999px;
  padding:8px;
  width: max-content;
`

export const BreadCrumbItem = styled.div`
  font-size: 14px;
  line-height: 100%;
  color: ${props => (props.isActive ? 'var(--color-text-dark)' : 'var(--color-text-gray)')};
  cursor: ${props => (props.onClick ? 'pointer' : 'default')};
  font-weight: 400;
  margin: 0px 5px 0px 5px;
`

export const Separator = styled.span`
  margin: 0 4px;
  color: var(--color-text-gray);
  display: flex;
`
